import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'security-code',
        loadComponent: () =>
          import('./security-code.component').then((m) => m.SecurityCodeComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class securityCodeRoutingModule {
  static routes = admin;
}
